exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".replicated-vdc, .replicated-vapp, .replicated-restore-point {\n  width: 100%; }\n\n.btn-restore-points {\n  text-decoration: underline;\n  cursor: pointer; }\n\n.btn-restore-points:hover {\n  text-decoration: none; }\n\n.replicated-vapp {\n  margin-top: 10px; }\n  .replicated-vapp .vdc-title {\n    padding-top: 10px;\n    padding-bottom: 10px; }\n  .replicated-vapp .vdc-detail {\n    border-bottom: 1px solid #eee;\n    padding: 0 0 10px 0; }\n  .replicated-vapp .vapp-title {\n    border-bottom: 1px solid #eee;\n    padding: 5px 0; }\n\n.replicated-side-list table {\n  margin-top: 10px; }\n\n.replicated-side-list td {\n  cursor: pointer;\n  padding-left: 4px !important; }\n\n.replicated-side-list td:hover {\n  background: #EEE; }\n\n.replicated-side-list td.selected {\n  background: #d9e4ea; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/replicated-vdc.scss
// module id = JNW/
// module chunks = 0